import { render } from "./AddNewAccount.vue?vue&type=template&id=0f3f7e1a"
import script from "./AddNewAccount.vue?vue&type=script&lang=js"
export * from "./AddNewAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__